import { observable, computed, action } from "mobx"
import shop from "shop/shop"


export default class ProductModel {
  @observable _count = 0

  constructor( data ) {
    this._type = "ProductModel"
    Object.assign( this, addImageLinks( data ) )
    // TODO GET REAL TAXRATE
    this.tax = 0
    this.taxRate = data.vat ? data.vat / 100 : 0.19
    console.log("ProductModel data", data)
    this.pinfos = this.pinfos || {}

    this.quantities = this.quantities || [{ map_desc_id: "NA", multi: 0 }]

    this.quantityById = {}
    this.quantities.forEach( q => {
      this.quantityById[ q.unit_id ] = q
    } )

    this.extras = this.extras || {}
    this.variant = this.extras.variant
    this.brand = this.extras.brand

    this.desc = this.desc || {}
    this.description = this.desc.des || ""
    this.excerpt = ""
    this.title = this.desc.short_des || ""

    const catId = this.cats && this.cats[ 0 ] && this.cats[ 0 ].cat_id
    this.category = shop.categoriesById.get( catId ) || {map_id: catId}

    this.isSale = false

    // Pre-Select the first quantity
    this.unit_id = this.quantities[ 0 ] ? this.quantities[ 0 ].map_desc_id : "NA"
    this.unit_multi = this.quantities[ 0 ] ? this.quantities[ 0 ].multi : 0
    this.unit_desc = this.quantities[ 0 ] ? this.quantities[ 0 ].des : ""

    this._count = 0
    this.available = true

    this.base_price = data.price

    this.updateDiscount()



  }

  calculate( count = this.count ) {
    this.setCount(count)
    this._sum = this.price * this.unit_multi * count
    return this._sum
  }

  getNotice() {
    return "Create an availability indicator in your ProductModel.getNotice() output"
  }

  get cartDescription() {
    return this.title
  }

  setPrice( price ) {
    this.price = price
  }

  setCount( count ) {
    this._count = count
    this.findBulkPrice()
    this.updateDiscount()
  }

  @computed
  get count() {
    return this._count
  }

  set count( value ) {
    this.setCount( value )
  }

  setDiscount(discount){
    this.extras._custom_discount = discount
    this.extras.custom_discount = -1 * discount
    this.updateDiscount()
  }

  updateDiscount(){
    if(this.extras.custom_discount){
      this.extras.custom_price = this.pinfos.brutto / 100 * (100 + Number(this.extras.custom_discount))
      this.extras.custom_price_sum = this.unit_multi * this.extras.custom_price * this.count

      this.extras.custom_discount_sum = this.unit_multi * this.extras.custom_price * this.count

      this.extras.custom_savings = this.pinfos.brutto -   this.extras.custom_price
      this.extras.custom_savings_sum = this.unit_multi * this.pinfos.brutto * this.count -  this.extras.custom_price_sum
    }
  }

  findBulkPrice() {

    // no bulk price
    if ( !this.prices ) {
      this.setPrice( this.price )
      return this.price
    }

    let count = this.count || 1
    let price = Infinity
    let n = count * this.unit_multi

    this.prices.forEach( bulkPrice => {
      if ( n >= bulkPrice.q ) {
        price = bulkPrice.p
      }
    } )

    if ( price === Infinity || !price ) {
      price = this.base_price
    }
    this.setPrice( price )
    return price
  }
}

export const productModelFactory = function ( Model ) {
  if ( !Model ) {
    return ProductModel
  }
  return class Model extends ProductModel {
  }
}


function ImageSet( id, key, description = "_" ) {
  let config = window.__bshop_config
  var data = {}
  data.img_src = config.MEDIA + description + "/" + id + "/" + key + "?size=small"
  data.img_src_small = config.MEDIA + description + "/" + id + "/" + key + "?size=small"
  data.img_src_medium = config.MEDIA + description + "/" + id + "/" + key + "?size=middle"
  data.img_src_large = config.MEDIA + description + "/" + id + "/" + key + "?size=large"
  return data
}

export const addImageLinks = function ( data = {} ) {
  let config = window.__bshop_config // this will break.
  if ( data && data.images && data.images.length > 0 ) {
    // prepare img source
    data.img_src = config.MEDIA + "description/" + data.map_pic_id + "/" + data.images[0] + "?size=small"
    data.img_src_small = config.MEDIA + "description/" + data.map_pic_id + "/" + data.images[0] + "?size=small"
    data.img_src_medium = config.MEDIA + "description/" + data.map_pic_id + "/" + data.images[0] + "?size=middle"
    data.img_src_hover = config.MEDIA + "description/" + data.map_pic_id + "/" + (data.images[1] ? data.images[1] : data.images[0])  + "?size=middle"
    data.img_src_large = config.MEDIA + "description/" + data.map_pic_id + "/" + data.images[0] + "?size=large"
    data.img_srcs = []

    if ( Array.isArray( data.images ) ) {
      data.images.forEach( ( imgKey ) => {
        data.img_srcs.push( new ImageSet( data.map_pic_id, imgKey ) )
      } )
    }
  } else {
    data.img_src = "/image/placeholder.png"
    data.img_src_small = "/image/placeholder.png"
    data.img_src_medium = "/image/placeholder.png"
    data.img_src_large = "/image/placeholder.png"
    data.img_srcs = []
  }
  return data
}



// WEBPACK FOOTER //
// ./src/sdk/ProductModel.js